import { useMemo } from "react";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

const COLORS = ["bg-primary", "bg-teal", "bg-secondary", "bg-blue", "bg-[#F0463C]"];

/** Gentle, calm confetti — drifts down slowly, never explosive. */
export function Confetti({ count = 18 }) {
  const pieces = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => ({
        id: i,
        left: Math.random() * 100,
        delay: Math.random() * 0.5,
        duration: 2.6 + Math.random() * 1.6,
        rotate: (Math.random() - 0.5) * 320,
        drift: (Math.random() - 0.5) * 80,
        color: COLORS[i % COLORS.length],
        size: 9 + Math.random() * 9,
        round: Math.random() > 0.5,
      })),
    [count],
  );

  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden>
      {pieces.map((p) => (
        <motion.span
          key={p.id}
          className={cn("absolute -top-6", p.color, p.round ? "rounded-full" : "rounded-[3px]")}
          style={{ left: `${p.left}%`, width: p.size, height: p.size }}
          initial={{ y: -30, x: 0, opacity: 0, rotate: 0 }}
          animate={{ y: "115vh", x: p.drift, opacity: [0, 1, 1, 0.8, 0], rotate: p.rotate }}
          transition={{ duration: p.duration, delay: p.delay, ease: "easeIn" }}
        />
      ))}
    </div>
  );
}

export default Confetti;
